import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeLemuComponent } from './home-lemu/home-lemu.component';
import { LogInComponent } from './log-in/log-in.component';

export const routes: Routes = [
  { path: '', component: LogInComponent },
  { path: 'login', component: LogInComponent },
  { path: 'home', component: HomeLemuComponent },
  // { path: '**', component: LogInComponent, pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
